export const PORTAL_TITLE = "Capital One Travel Portal";
export const SEARCH_PACKAGE_TITLE = "Search a package";
export const SELECT_HOTEL_TITLE = "Select a hotel";
export const SELECT_ROOM_TITLE = "Select a room";
